export function initMyPageWebinarFavorite() {
    allDisplayOn();
    allDisplayOff();
}
/** すべて表示 */
const allDisplayOn = () => {
    const buttonMoreButtons = document.querySelectorAll(".button-more");
    if (!buttonMoreButtons)
        return;
    for (const buttonMoreButton of buttonMoreButtons) {
        const seriesIndex = buttonMoreButton.dataset.mypagewebinarseriesindex;
        if (!seriesIndex)
            return;
        buttonMoreButton.addEventListener("click", () => {
            const defaultHiddenAreas = document.querySelectorAll(".defaultHidden_" + seriesIndex);
            if (!defaultHiddenAreas)
                return;
            for (const defaultHiddenArea of defaultHiddenAreas) {
                defaultHiddenArea.style.display = "";
            }
            const buttonMore = document.querySelector("#buttonMore_" + seriesIndex);
            if (!buttonMore)
                return;
            buttonMore.style.display = "none";
            const buttonLess = document.querySelector("#buttonLess_" + seriesIndex);
            if (!buttonLess)
                return;
            buttonLess.style.display = "";
        });
    }
};
/** 少なく表示 */
const allDisplayOff = () => {
    const buttonLessButtons = document.querySelectorAll(".button-less");
    if (!buttonLessButtons)
        return;
    for (const buttonLessButton of buttonLessButtons) {
        const seriesIndex = buttonLessButton.dataset.mypagewebinarseriesindex;
        if (!seriesIndex)
            return;
        buttonLessButton.addEventListener("click", () => {
            const defaultHiddenAreas = document.querySelectorAll(".defaultHidden_" + seriesIndex);
            if (!defaultHiddenAreas)
                return;
            for (const defaultHiddenArea of defaultHiddenAreas) {
                defaultHiddenArea.style.display = "none";
            }
            const buttonMore = document.querySelector("#buttonMore_" + seriesIndex);
            if (!buttonMore)
                return;
            buttonMore.style.display = "";
            const buttonLess = document.querySelector("#buttonLess_" + seriesIndex);
            if (!buttonLess)
                return;
            buttonLess.style.display = "none";
        });
    }
};
